<template>
  <ProgressLoader
    v-if="loading"
    mode="indeterminate"
    color="#5AC396"
    size="150px"
  />

  <div v-else>
    <AuBreadcrumb :pages="breadcrumb" />
    <div class="card voting">
      <div class="title">
        {{ $t("votingProtocol.title") }}
      </div>
      <AuTable
        :columns="columns"
        :items="items"
      />
      <AuPagination
        v-if="daoEventsTotal > itemsPerPage"
        :total-items="daoEventsTotal"
        @pageChanged="changePage"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ProgressLoader from "@/loaders/progress-bar";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "VoitingProtocol",
  components: { ProgressLoader },
  props: {
    id: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      page: 1,
      itemsPerPage: 30,
      loading: true,
      capital: {}
    };
  },

  computed: {
    ...mapGetters({
      daoEvents: "dao/daoEvents",
      daoEventsTotal: "dao/daoEventsTotal"
    }),

    columns() {
      return [
        { name: this.$t("votingProtocol.adr"), align: "left" },
        { name: this.$t("votingProtocol.count"), align: "left" }
      ];
    },

    items() {
      return _.map(this.daoEvents, (event) => ({
        address: event.address,
        amount: event.amount
      }));
    },

    clearId() {
      const pos = this.id.indexOf("&");
      return pos === -1 ? this.id : this.id.slice(0, pos);
    },

    projectId() {
      const pos = this.id.indexOf("&");
      return pos === -1 ? 0 : this.id.slice(pos).replace(/\D/g, "");
    },

    breadcrumb() {
      const breadcrumb = [
        { key: 0, name: this.$t("router.pages.project"), path: "/my-projects" }
      ];
      if (this.capital?.tokenBase?.nameEng) {
        breadcrumb.push({
          key: breadcrumb?.length,
          name: this.capital?.tokenBase?.nameEng,
          path: `/project-card/${this.projectId}`
        });
      }
      breadcrumb.push({
        key: breadcrumb?.length,
        name: this.$t("router.pages.daoTokens"),
        path: `/dao-tokens/${this.projectId}`
      });
      return breadcrumb;
    }
  },

  async mounted() {
    await this.getEvents();
    this.capital = await this.getAuCapitals(this.projectId);
    this.loading = false;
  },

  methods: {
    ...mapActions({
      getDaoEvents: "dao/getDaoEvents",
      getAuCapitals: "capitals/getAuCapitals"
    }),

    async changePage(page) {
      this.page = page;
      await this.getEvents();
    },

    async getEvents() {
      const params = {
        page: this.page,
        itemsPerPage: this.itemsPerPage,
        requestId: this.clearId
      };
      await this.getDaoEvents(params);
    }
  }
};
</script>

<style scoped lang="scss">
.voting {
  padding: 20px;

  .title {
    font-size: 24px;
    color: var(--text-color);
    line-height: 1.1;
    margin-bottom: 20px;
  }
}
</style>